<template>
  <div class="text-center">
    <v-form class="login">
          <v-flex class="text-center mt-12">
            <img
                src="@/assets/images/askme.png"
            />
            <div class="caption font-weight-thin">v{{$constants.application.version}}</div>
          </v-flex>
        <v-flex class="text-center mt-12">
            <v-text-field
              v-model="userName"
              label="E-mail"
              clearable
              rounded
              filled
              background-color="#FFFFFF88"
              color="black"
            ></v-text-field>

            <v-text-field
              v-model="password"
              :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show ? 'text' : 'password'"
              label="Password"
              rounded
              filled
              background-color="#FFFFFF88"
              color="black"
              @click:append="show = !show"
            ></v-text-field>
            <v-checkbox
              v-model="rememberMe"
              label="Se souvenir de moi"
              color="white"
              class="mt-0"
              hide-details
            />
            <v-alert
              v-if="errorMessage"
              type="error"
              dense
              class="mt-6 mb-0 text-left"
            >{{ errorMessage }}</v-alert>
            <v-btn class="mt-12" outlined rounded x-large color="white" @click="onClickBtnConnect()">CONNEXION</v-btn>
            
        </v-flex>
    </v-form>
  </div>
</template>

<script>
import sha1 from 'sha1';

export default {
  name: 'ALoginForm',
  data: () => ({
    userName: '',
    password: '',
    rememberMe: false,
    show: true,
    errorMessage: ''
  }),
  watch: {
    // Le message d'échec disparaît dès que l'utilisateur corrige sa saisie
    userName() { this.errorMessage = '' },
    password() { this.errorMessage = '' }
  },
  mounted() {
    const remembered = localStorage.getItem('askme.login.remember')
    if (remembered) {
      try {
        const { userName, password } = JSON.parse(remembered)
        this.userName = userName || ''
        this.password = password || ''
        this.rememberMe = true
      } catch (e) {
        localStorage.removeItem('askme.login.remember')
      }
    }
  },
  methods: {
    loginErrorMessage(error) {
      const key = !error ? 'missingUser'
        : !error.response ? 'serverUnreachable'
        // Mot de passe initial périmé : un lien vient d'être envoyé par e-mail (SEC-24)
        : error.response.status === 401 && error.response.data === 'Password expired' ? 'passwordExpired'
        : error.response.status === 429 ? 'tooManyAttempts'
        : error.response.status === 401 ? 'badCredentials'
        : 'serverError'
      return this.$vuetify.lang.t(`$vuetify.login.${key}`)
    },
    onClickBtnConnect: function () {
      this.errorMessage = ''
      if (this.rememberMe) {
        localStorage.setItem(
          'askme.login.remember',
          JSON.stringify({ userName: this.userName, password: this.password })
        )
      } else {
        localStorage.removeItem('askme.login.remember')
      }

      let loginData = {
            environment: this.environment,
            user: this.userName,
            password: sha1(this.password),
            ip: this.$store.state.ip,
            offset: -(new Date()).getTimezoneOffset()
        }
                    
        this.$store.dispatch('login', loginData)
            .then((token) => {                                                                                                                  
                this.$root.$emit('login', token);                    
            })      
            .catch(error => {            
                console.log(error)
                this.errorMessage = this.loginErrorMessage(error)
                if (error && error.response && error.response.status === 401) this.$root.$emit("logout");
                else if (error) this.$root.$emit("serverError", error);
            });                        
    }
  }
}
</script>

<style scoped>
img {
  max-width: 150px;
}

.login {
  max-width: 350px;
  margin-left: auto;
  margin-right: auto;
}
</style>
